module.exports = "/wwwroot/img/map.png?ver=bf5afc06";